var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRefresh = function SvgIconRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.533 8.953a.667.667 0 0 0-.833.434 4.76 4.76 0 0 1-4.58 3.28A4.734 4.734 0 0 1 3.333 8 4.733 4.733 0 0 1 8.12 3.333a4.84 4.84 0 0 1 3.1 1.114l-1.447-.24a.667.667 0 0 0-.757.814.667.667 0 0 0 .544.506l2.827.466h.113a.667.667 0 0 0 .227-.04.219.219 0 0 0 .066-.04.52.52 0 0 0 .134-.073l.06-.073c0-.034.06-.06.086-.1.027-.04 0-.067.034-.094a.89.89 0 0 0 .046-.12l.5-2.666a.678.678 0 1 0-1.333-.254l-.18.967A6.14 6.14 0 0 0 8.12 2 6.067 6.067 0 0 0 2 8a6.067 6.067 0 0 0 6.12 6A6.08 6.08 0 0 0 14 9.787a.666.666 0 0 0-.467-.834Z",
    fill: "#fff",
    fillOpacity: 0.5
  })));
};
export default SvgIconRefresh;